import { Component, OnInit, OnDestroy} from '@angular/core';
import { HeaderService } from '../../tools/header.service';

@Component({
  selector: 'hiddenReference',
  templateUrl: './hiddenReferences.component.html',
  styleUrls: ['./hiddenReferences.component.scss']
})

export class HiddenReferences implements OnInit, OnDestroy{
  
  constructor(private headerService: HeaderService) { }

  ngOnInit() {
    this.headerService.changeTitle("common.info");
    this.headerService.changeCanBack(true);
    this.headerService.changeLogo(null);
  }

  ngOnDestroy() {

  }
}
